import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { translatePlain } from '@avp/core'
import { storeUserGarageVehicleAsync } from '../../actions/app/userGarage.actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'

const trackUserGarageButtonMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(storeUserGarageVehicleAsync.success, action)) {
        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc save to garage',
            },
            attributes: {
                componentName: 'cartbox',
                label: translatePlain('garage.userGarage.cartboxButtonLabel'),
                currentURL: window.location.href,
                targetURL: '',
                clickID: '',
                elementName: 'button',
                value: 'vehicle-saved',
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackUserGarageButtonMiddleware
